<template>
  <div class="toPay">
    <!-- 结账 -->
    <md-popup v-model="show" :mask-closable="false">
      <md-popup-title-bar :title="type?'直接还款':'订单还款'" :only-close="true" @cancel="closePop(2)"></md-popup-title-bar>
      <div class="box">
        <div class="box_content">
          <div class="b_c_left">
            <div >
              <div class="box_header"> <div>{{buyer_name}}</div> </div>
              <div class="b_c_left_1">
                <div class="receivables"> 应还：￥{{receivables?Number(receivables):0}} </div>
              </div>
            </div>
            <div class="pay_type">
              <div
                v-for="(item,index) in pay_type_list"
                :key="index"
                @click="subData.repayment_type = item.value"
                v-show="!(!union_pay && item.value == 5)" 
              >
                <span>
                  <img :src="item.icon" alt />
                </span>
                <span>{{item.name}}</span>
                <span>
                  <md-radio :name="item.value" v-model="subData.repayment_type" inline />
                </span>
              </div>
            </div>
          </div>
          <div class="b_c_right">
            <div class="amount_box">
              <!-- 实收 -->
              <div
                class="pop_changeGood_info_inputBox"
                :focus="p_key.active_name == 'repayment_amount'"
                @click="selectInput('repayment_amount',2)"
              >
                <span>还款</span>
                <input type="text" v-model="subData.repayment_amount" readonly />
                <span>元</span>
              </div>
              <!-- 优惠多收 -->
              <div
                class="pop_changeGood_info_inputBox"
                :focus="p_key.active_name == 'discount_amount'"
                @click="selectInput('discount_amount',2)"
              >
                <span >优惠</span>
                <input type="text" v-model="subData.discount_amount" readonly />
                <span>元</span>
              </div>
              <!-- 赊欠 -->
              <div
                class="pop_changeGood_info_inputBox"
                style="border-color:#f1f1f1;user-select:none;"
              >
                <span v-if="subData.remaining<0">超出</span>
                <span v-else>未还</span>
                <input type="text" :value="Math.abs(subData.remaining)" readonly />
                <span>元</span>
              </div>
            </div>
            <div class="amount_keyBoard">
              <KeyBoard
                ref="amountKeyBoard"
                @finish="handleChangeGoodFinish"
                :k_decimal="p_key.decimal"
                :k_finish_disabled="p_key.finish_disabled"
                v-model="p_key.value"
                @input="handleChangeInput"
              ></KeyBoard>
            </div>
          </div>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import KeyBoard from "@/components/KeyBoard";
import Cookies from "@/utils/Cookies";
import { timestampToDate, timestampToTime,longtimestampToTime } from "@/utils/timestamp";
import { credit_payment_buyer, credit_payment_order,repayment_pay_pos,repayment_check_pos } from "@/api/work/credit";

export default {
  name: "toPay",
  components: {
    KeyBoard
  },
  data() {
    return {
      union_pay:JSON.parse(Cookies.get("shopInfo")).union_pay || 0 , // 是否支持pos支付
      type: '1',
      show:false,
      buyer_name: "",
      receivables:0,
      subData:{
        buyer_id:'', // 买家id 按单还款时不需要
        credit_ids:'', // 订单id字符串（，） 根据客户还款时不需要
        repayment_amount:'', // 还款金额
        discount_amount:'', // 优惠金额
        repayment_type:'1', // 还款方式[1现金; 2支付宝; 3微信; 4银行卡]
        remaining:'', // 剩余未还
      },
      p_key: {
        active_name: "",
        decimal: 2,
        value: "",
        finish_disabled:true
      },
      pay_type_list: [
        {
          value: "1",
          name: "现金",
          icon: require("@/assets/img/work/open/pay_type_cash.png")
        },
        {
          value: "2",
          name: "支付宝",
          icon: require("@/assets/img/work/open/pay_type_ali.png")
        },
        {
          value: "3",
          name: "微信",
          icon: require("@/assets/img/work/open/pay_type_wx.png")
        },
        {
          value: "4",
          name: "银行卡",
          icon: require("@/assets/img/work/open/pay_type_bank.png")
        },
        {
          value: "5",
          name: "POS",
          icon: require("@/assets/img/work/open/pay_type_pos.png")
        }
      ],
      count:0,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 显示弹窗 type == 1 按单还款 data:{buyer_name,receivables,credit_ids} ;type == 2 直接还款data:{buyer_name,receivables,buyer_id}
    showPop(type,data){
      if(type == 1){
        this.type = 1
        this.buyer_name = data.buyer_name || ''
        this.receivables = data.receivables || 0
        this.subData.buyer_id = data.buyer_id
        this.selectInput('repayment_amount',2)
      }else{
        this.type = 2
        this.buyer_name = data.buyer_name || ''
        this.receivables = data.receivables || 0
        this.subData.credit_ids = data.credit_ids
        this.selectInput('repayment_amount',2)
      }
      this.p_key.finish_disabled = true
      this.show = true
    },
    // 关闭弹窗
    closePop(type) {
      // type == 1 完成 2 == 取消
      this.show = false
      this.count = 0
      this.resetData()
      this.$emit("cancel", type);
    },
    // 重置数据
    resetData(){
      this.subData = {
        buyer_id:'', 
        credit_ids:'', 
        repayment_amount:'', 
        discount_amount:'',
        repayment_type:'1',
        remaining:'', 
      }
    },

    // 点击输入框
    selectInput(name, decimal) {
      this.p_key.active_name = name;
      this.p_key.decimal = decimal;
      this.p_key.value = Number(this.subData[this.p_key.active_name]) + "";
      this.$refs.amountKeyBoard.clear();
    },

    // 数据输入中
    handleChangeInput(val) {
      this.subData[this.p_key.active_name] = val;
      this.subData.remaining = Math.round(Number(this.receivables) * 100  -  Number(this.subData.repayment_amount) * 100 - Number(this.subData.discount_amount) * 100 ) / 100
      if(this.subData.remaining<0 || this.subData.repayment_amount<=0){
        this.p_key.finish_disabled = true
      }else{
        this.p_key.finish_disabled = false
      }
    },

    // 数据修改完成
    handleChangeGoodFinish() {
      if(this.subData.repayment_type == 5){
        this.count = 0
        this.$router.push({
          path: "/public/scan",
          query: {
            message: "",
            reg: "^[0-9]{10,50}$"
          }
        });
      }else{
        this.createOrder().then(res=>{})
      }
    },

    // 创建订单
    createOrder(){
      return new Promise((resolve, reject)=>{
        //还款
        if(this.type == 1){
          // 按买家
          var subData = JSON.parse(JSON.stringify(this.subData))
          subData.discount_amount = subData.discount_amount || 0
          subData.repayment_amount =Math.round(( Number(subData.repayment_amount) + Number(subData.discount_amount))*100)/100
          delete subData.credit_ids
          delete subData.remaining
          credit_payment_buyer(subData).then(res=>{
            if(res.code == 200){
              if(subData.repayment_type == 5){
                resolve(res)
              }else{
                this.printOrderInfo(res.data)
                this.$toast.succeed(res.message)
                this.resetData()
                this.show = false
                this.$emit("finish")
                resolve(res)
              }
            }
          })
        }else{
          // 按订单
          var subData = JSON.parse(JSON.stringify(this.subData))
          subData.discount_amount = subData.discount_amount || 0
          subData.repayment_amount =Math.round(( Number(subData.repayment_amount) + Number(subData.discount_amount))*100)/100
          delete subData.buyer_id
          delete subData.remaining
          credit_payment_order(subData).then(res=>{
            if(res.code == 200){
              if(subData.repayment_type == 5){
                resolve(res)
              }else{
                this.printOrderInfo(res.data)
                this.$toast.succeed(res.message)
                this.resetData()
                this.show = false
                this.$emit("finish")
                resolve(res)
              }
            }
          })
        }
      })
    },

    
    // pos 收款
    posPay(pay){
      var auth_code = pay;
      this.$toast.loading("支付中...");
      this.createOrder().then(res=>{
        if(res.data.annal_pay_no){
          repayment_pay_pos({auth_code,annal_pay_no:res.data.annal_pay_no}).then(res_p=>{
            if( res_p.code == 200){
              if(res_p.data.pay_code == 200){
                this.printOrderInfo(res_p.data)
                this.$toast.succeed(res_p.message)
                this.resetData()
                this.show = false
                this.$emit("finish")
              }else{
                setTimeout(()=>{
                  this.checkPayStatus(res.data.annal_pay_no)
                },3000)
              }
            }
          })
        }
      })
    },

    // 查询pos支付状态
    checkPayStatus(annal_pay_no){
      this.count ++ ;
      if(this.count<5){
        repayment_check_pos({annal_pay_no}).then(res=>{
          if(res.code == 200){
            if(res.data.pay_code == 200){
              this.printOrderInfo(res.data)
              this.$toast.succeed(res.message)
              this.resetData()
              this.show = false
              this.$emit("finish")
            }else{
              setTimeout(()=>{
                this.checkPayStatus(annal_pay_no)
              },3000)
            }
          }
        })
      }else{
        this.$toast.failed("支付失败！")
      }
    },

    // 打印订单信息
    printOrderInfo(data){
      var p_data = data 
      p_data.shop_name = JSON.parse(Cookies.get("shopInfo")).shop_name || ""
      try {
        this.$toast.loading('正在打印中')
        var result= plus.bridge.execSync('sunmiPrint','printRefund',[JSON.stringify(p_data)])
        if(result.code == 200){
          this.$toast.succeed('打印成功')
        }else{
          this.$toast.failed(result.message)
        }
      } catch (error) {
        
      }
    },

  }
};
</script>

<style lang="less" scoped>
.toPay {
  position: relative;
  .md-popup-mask {
    top: 0;
    left: 0;
  }
  .box {
    width: 8.25rem;
    background-color: #fff;
    border-radius: 0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding: 0.2rem;
    padding-top: 0;
    .box_header {
      line-height: 0.48rem;
      color: #404040;
      font-weight: bold;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      font-size: 0.32rem;
      margin: 0.5rem 0 0.06rem;
      .select_buyer {
        width: 3.4rem;
      }
      .shop_buyer_add {
        width: 1.28rem;
        height: 0.48rem;
        background-color: #31b158;
        line-height: 0.48rem;
        text-align: center;
        color: #fff;
        font-size: 0.24rem;
        border-radius: 0.04rem;
        margin-left: 0.1rem;
      }
    }
    .box_content {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .b_c_left {
        width: 44%;
        height: 5.4rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .b_c_left_1 {
          // margin-bottom: 1rem;
          .receivables {
            padding: 0.1rem 0;
            font-size: 0.24rem;
            color: #404040;
            span {
              font-size: 0.44rem;
              vertical-align: middle;
              color: #f79a07;
              line-height: 0.6rem;
            }
          }
          .remarks {
            display: flex;
            align-items: flex-start;

            textarea {
              width: 2.4rem;
              border: 0.01rem solid #e1e1e1;
              padding: 0.08rem;
            }
          }
        }
        .pay_type {
          border-top: 0.01rem solid #e1e1e1;
          height: 3.4rem;
          display: flex;
          align-items: center;
          justify-content: space-around;
          flex-direction: column;
          & > div {
            width: 100%;
            height: 0.68rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span:nth-child(1) {
              width: 0.4rem;
              margin-right: 0.1rem;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 0.28rem;
              }
            }
            span:nth-child(2) {
              flex: 1;
            }
            span:nth-child(3) {
              width: 0.4rem;
            }
          }
        }
      }
      .b_c_right {
        width: 54%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .amount_box {
          height: 2rem;
        }
        .pop_changeGood_info_inputBox {
          width: 100%;
          display: flex;
          align-items: center;
          line-height: 0.48rem;
          border-radius: 0.03rem;
          border: 0.01rem solid #e1e1e1;
          box-sizing: border-box;
          padding: 0 0.1rem;
          margin: 0.1rem 0;
          &[focus] {
            border-color: #31b158;
            input {
              animation: inputFocus 0.8s linear infinite;
              @keyframes inputFocus {
                0% {
                  border-color: #31b158;
                }
                50% {
                  border-color: transparent;
                }
                100% {
                  border-color: #31b158;
                }
              }
            }
          }
          input {
            width: 3.2rem;
            // flex: 1;
            text-align: right;
            padding: 0 0.1rem;
            height: 0.26rem;
            text-align: right;
            padding: 0 0.1rem;
            padding-right: 0.05rem;
            margin-right: 0.05rem;
            border-right: 0.02rem solid transparent;
            border-radius: 0;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.toPay {
  .el-select {
    input {
      font-size: 0.24rem !important;
      height: 0.48rem !important;
      color: #2c3e50;
      background-color: #e1e1e1;
      &.el-input__inner {
        border: none !important;
      }
    }
    .el-input__icon {
      font-size: 0.24rem !important;
      color: #888 !important;
    }
    .el-input__suffix {
      right: 0.1rem !important;
    }
  }
  .el-select-dropdown {
    max-width: 3.37rem;
    height: 5.2rem;
    .el-select-dropdown__wrap {
      max-height: 5.2rem !important;
    }
    .el-select-dropdown__item {
      font-size: 0.22rem !important;
      line-height: 0.48rem !important;
      height: 0.48rem !important;
    }
  }
  .el-select-dropdown__empty {
    font-size: 0.22rem !important;
  }
}
</style>